// extracted by mini-css-extract-plugin
export default {"box":"file-html_box__IQMBd","download":"file-html_download__MACqj","preview":"file-html_preview__vaYg1"};